Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing,
    fontRegular = _STYLES$useStyles.fontRegular;
  var container = {
    alignItems: 'center',
    width: '100%'
  };
  var _image = {
    width: 101,
    height: 70,
    marginBottom: spacing.xs
  };
  var image = Object.assign({}, _image);
  var text = Object.assign({}, fontRegular, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    textAlign: 'center'
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    image: image,
    text: text
  });
  return {
    styles: styles
  };
};